import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-localdb-type-service',
    templateUrl: './localdb-type-service.component.html',
    styleUrls: ['./localdb-type-service.component.scss'],
    standalone: false
})
export class LocaldbTypeServiceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
